// extracted by mini-css-extract-plugin
export default {"content":"page_content__HEq9x","title":"page_title__OdSIK","cards":"page_cards__wXfmP","icon":"page_icon__902Ss"};